import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  doctor: any;

  api: string = environment.baseUrl;

  constructor(private http: HttpClient) { }

  searchDoctors = (req: object) => this.http.post<any>(this.api + "HcpRequest/search", req);

  // lookUps
  
  getInsuranceCompanies = (req: object) => this.http.post<any>(this.api + "InsuranceCompanies/Search", req);

  getLanguages = (req: object) => this.http.post<any>(this.api + "Languages/Search", req);

  getSpecialities = (MedicalServiceId) => this.http.get<any>(this.api + "Speciality?MedicalServiceId=" + MedicalServiceId);

  getMedicalServices = () => this.http.get<any>(this.api + "MedicalService");

  getAllLocations = () => this.http.get<any>(this.api + "Locations/AllLocations");


}
